import React from 'react';
import { Grid } from '@mui/material';

import { CurrencyTextField, DateField, ModuleSearchField, SimpleTextField, useSettings } from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function ErpOrdersDetailsSectionInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();

	return (
		<>
			<Grid size={{ md: 3, sm: 6, xs: 12 }}>
				{/* NAV CODE */}
				<SimpleTextField
					name="ords_erp_id"
					label={t('DETAILS_ERP_ORDERS_FIELD_CODE')}
					value={props.model.ords_erp_id}
					isEdit={false}
					sendChange={props.sendChange}
				/>
			</Grid>
			<Grid size={{ md: 3, sm: 6, xs: 12 }}>
				{/* ORDER DATE */}
				<DateField
					name="ords_d_order"
					label={t('DETAILS_ERP_ORDERS_FIELD_DATE_ORDER')}
					value={props.model.ords_d_order}
					isEdit={false}
					sendChange={props.sendChange}
				/>
			</Grid>
			<Grid size={{ md: 3, sm: 6, xs: 12 }}>
				{/* REQUESTED DELIVERY DATE */}
				<DateField
					name="ords_d_delivery_requested"
					label={t('DETAILS_ERP_ORDERS_FIELD_DATE_DATE_REQDELIVERY')}
					value={props.model.ords_d_delivery_requested}
					isEdit={false}
					sendChange={props.sendChange}
				/>
			</Grid>
			<Grid size={{ md: 3, sm: 6, xs: 12 }}>
				{/* PROMISED DELIVERY DATE */}
				<DateField
					name="ords_d_delivery_promised"
					label={t('DETAILS_ERP_ORDERS_FIELD_DATE_DATE_PROMDELIVERY')}
					value={props.model.ords_d_delivery_promised}
					isEdit={false}
					sendChange={props.sendChange}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* CUSTOMER */}
				<ModuleSearchField
					name="ords_comp_uid"
					label={t('DETAILS_ERP_ORDERS_FIELD_COMPANY')}
					module="companies"
					uid={props.model.ords_comp_uid}
					isEdit={false}
					sendChange={props.sendChange}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* BILLING COMPANY */}
				<ModuleSearchField
					name="ords_bill_comp_uid"
					label={t('DETAILS_ERP_ORDERS_FIELD_BILL_COMPANY')}
					module="companies"
					uid={props.model.ords_bill_comp_uid}
					isEdit={false}
					sendChange={props.sendChange}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* SALESPERSON */}
				{props.model.ords_user_salesperson_uid ? (
					<ModuleSearchField
						name="ords_user_salesperson_uid"
						label={t('DETAILS_ERP_ORDERS_FIELD_SALESPERSON')}
						module="users"
						uid={props.model.ords_user_salesperson_uid}
						isEdit={false}
						sendChange={props.sendChange}
					/>
				) : (
					<SimpleTextField
						name="ords_user_salesperson_title"
						label={t('DETAILS_ERP_ORDERS_FIELD_SALESPERSON')}
						value={props.model.ords_user_salesperson_title}
						isEdit={false}
						sendChange={props.sendChange}
					/>
				)}
			</Grid>
			<Grid size={{ md: 3, sm: 6, xs: 12 }}>
				{/* TOT TAX EXCLUDED */}
				<CurrencyTextField
					name="ords_tot_value_tax_excl"
					label={t('DETAILS_ERP_ORDERS_FIELD_TOT_TAX_EXCL')}
					value={props.model.ords_tot_value_tax_excl}
					isEdit={false}
					sendChange={props.sendChange}
				/>
			</Grid>
			<Grid size={{ md: 3, sm: 6, xs: 12 }}>
				{/* TOT TAX INCLUDED */}
				<CurrencyTextField
					name="ords_tot_value_tax_incl"
					label={t('DETAILS_ERP_ORDERS_FIELD_TOT_TAX_INCL')}
					value={props.model.ords_tot_value_tax_incl}
					isEdit={false}
					sendChange={props.sendChange}
				/>
			</Grid>
		</>
	);
}
